const imageUrl = "https://stageapi-simulations.meseekna.com/download/"
export const environment = {
  imageUrl,
  fallback_img_url: "",
}
export const simLogos: { [key: string]: string } = {
  coastarea: "/v3/assets/sim-logos/coastarea-logo.png",
  rootsAndShoots: "/v3/assets/sim-logos/roots-and-shoots-logo.png",
  silverStreak: "/v3/assets/sim-logos/silver-streak-logo.png",
}
